// extracted by mini-css-extract-plugin
export default {"icon":"icon__NZL9M"};